import { utilities } from 'core/use-cases';

import { GENERIC_ERROR_ID, UNCLASSIFIED_ERROR_ID } from './error-id';

export function errorHandleInvalidCredentials(action: utilities.ActionFailure) {
  if (action?.error) {
    const { response } = action.error;

    return (
      action.type === 'userFetchFailure' ||
      response?.errorId === UNCLASSIFIED_ERROR_ID.INVALID_CREDENTIALS ||
      response?.errorId === GENERIC_ERROR_ID.INVALID_TOKEN_OR_EXPIRATED
    );
  }

  return false;
}
